import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorQuotationCartSearch = () => {
  const cartSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/rfq-cart/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { cartSearch }
}

export default InteractorQuotationCartSearch
